// src/components/admin/TorreDeControl/modals/StatusModal.jsx
import React, { useState } from 'react';
import { X, AlertCircle, CheckCircle, XCircle, Clock, Truck } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

function StatusModal({ item, itemType, onClose, onUpdate }) {
  const [selectedStatus, setSelectedStatus] = useState(item.status);
  const [isLoading, setIsLoading] = useState(false);

  const deliveryStatuses = [
    { value: 'pending', label: 'Pendiente', icon: Clock, color: 'bg-yellow-100 border-yellow-300 text-yellow-800' },
    { value: 'encamino', label: 'En camino', icon: Truck, color: 'bg-blue-100 border-blue-300 text-blue-800' },
    { value: 'entregado', label: 'Entregado', icon: CheckCircle, color: 'bg-green-100 border-green-300 text-green-800' },
    { value: 'cancelado', label: 'Cancelado', icon: XCircle, color: 'bg-gray-100 border-gray-300 text-gray-800' },
    { value: 'rechazado', label: 'Rechazado', icon: XCircle, color: 'bg-red-100 border-red-300 text-red-800' },
    { value: 'postergado', label: 'Postergado', icon: Clock, color: 'bg-orange-100 border-orange-300 text-orange-800' },
  ];

  const orderStatuses = [
    { value: 'pending', label: 'Pendiente', icon: Clock, color: 'bg-yellow-100 border-yellow-300 text-yellow-800' },
    { value: 'encamino', label: 'En camino', icon: Truck, color: 'bg-blue-100 border-blue-300 text-blue-800' },
    { value: 'completado', label: 'Recogido', icon: CheckCircle, color: 'bg-green-100 border-green-300 text-green-800' },
    { value: 'cancelado', label: 'Cancelado', icon: XCircle, color: 'bg-gray-100 border-gray-300 text-gray-800' },
  ];

  const statuses = itemType === 'delivery' ? deliveryStatuses : orderStatuses;

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    try {
      const endpoint =
        itemType === 'delivery'
          ? `${API_URL}/api/admin/delivery-point/${item.id}/status`
          : `${API_URL}/api/admin/order/${item.id}/status`;

      await axios.put(endpoint, { status: selectedStatus });
      onUpdate();
      onClose();
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Error al actualizar estado');
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10000] p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="bg-[#B1336E] px-6 py-4 flex items-center justify-between">
          <h3 className="text-white font-bold text-lg flex items-center gap-2 font-montserrat">
            <AlertCircle className="w-5 h-5" />
            Cambiar Estado
          </h3>
          <button
            onClick={onClose}
            className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="space-y-2">
            {statuses.map((status) => {
              const Icon = status.icon;
              const isSelected = selectedStatus === status.value;
              
              return (
                <button
                  key={status.value}
                  type="button"
                  onClick={() => setSelectedStatus(status.value)}
                  className={`w-full flex items-center gap-3 p-4 rounded-lg border-2 transition-all font-montserrat ${
                    isSelected
                      ? `${status.color} border-opacity-100 shadow-md`
                      : 'bg-white border-slate-200 hover:border-slate-300'
                  }`}
                >
                  <Icon className={`w-5 h-5 ${isSelected ? '' : 'text-slate-400'}`} />
                  <span className={`font-medium ${isSelected ? '' : 'text-slate-700'}`}>
                    {status.label}
                  </span>
                  {isSelected && (
                    <CheckCircle className="w-5 h-5 ml-auto" />
                  )}
                </button>
              );
            })}
          </div>

          <div className="flex gap-3 pt-4 border-t border-slate-200">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-slate-200 hover:bg-slate-300 text-slate-700 px-4 py-2 rounded-lg font-medium transition-colors font-montserrat"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={isLoading || selectedStatus === item.status}
              className="flex-1 bg-[#B1336E] hover:bg-[#B1336E]/90 disabled:bg-slate-300 text-white px-4 py-2 rounded-lg font-medium transition-colors font-montserrat"
            >
              {isLoading ? 'Guardando...' : 'Guardar Estado'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default StatusModal;